import {
  Chat,
  ChatResponse,
  ChatSummary,
  ChatSummaryResponse,
} from 'types/chat';
import { transformModelsConversation } from './transformModelsConversation';

export function transformChatResponse(chat: ChatResponse): Chat;
export function transformChatResponse(chat: ChatSummaryResponse): ChatSummary;
export function transformChatResponse(
  chat: ChatResponse | ChatSummaryResponse,
): Chat | ChatSummary {
  const { chatId, name, updatedAt, isPinned, projectId } = chat;

  if ('additional' in chat) {
    return {
      id: chatId,
      name,
      date: updatedAt,
      isPinned,
      projectId,
      additional: chat.additional,
      jurisdiction: chat.jurisdiction,
      mode: chat.expertise,
      models: transformModelsConversation(chat.expertModes),
      themeOptions: chat.customFields,
    };
  }

  return {
    id: chatId,
    name,
    date: updatedAt,
    isPinned,
    projectId,
    mode: chat.expertise,
    models: chat.expertModes.map((model) => ({
      id: model.id,
      name: model.name,
      expertRole: model.expertRole,
      order: model.order,
      status: model.modeStatus,
    })),
  };
}
